// 라인 아이콘 (디자인 핸드오프 bwek-core.jsx). 1.6px stroke, round. 외부 의존 없음.
interface IconProps {
  size?: number;
  stroke?: number;
  color?: string;
}

function svg(children: React.ReactNode) {
  return function Icon({ size = 18, stroke = 1.6, color = "#fff" }: IconProps) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ display: "block", flex: "0 0 auto" }}
      >
        {children}
      </svg>
    );
  };
}

export const IconBack = svg(
  <>
    <line x1="19" y1="12" x2="5" y2="12" />
    <polyline points="11 6 5 12 11 18" />
  </>,
);

export const IconAgain = svg(
  <>
    <path d="M4 8 a8 8 0 1 1 -1.2 6" />
    <polyline points="4 3 4 8 9 8" />
  </>,
);

export const IconSave = svg(
  <>
    <path d="M5 15v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3" />
    <polyline points="8 11 12 15 16 11" />
    <line x1="12" y1="4" x2="12" y2="15" />
  </>,
);

export const IconShare = svg(
  <>
    <circle cx="6" cy="12" r="2.4" />
    <circle cx="17.5" cy="6" r="2.4" />
    <circle cx="17.5" cy="18" r="2.4" />
    <line x1="8.1" y1="10.9" x2="15.4" y2="7.1" />
    <line x1="8.1" y1="13.1" x2="15.4" y2="16.9" />
  </>,
);
